module.exports = __webpack_public_path__ + "img/index-s4.81e3dee1.png";